import { useQueryClient } from "@tanstack/react-query";
import { optionsKeys } from "PFCore/hooks/queries/options";
import { FetchOptionsResponse, Option, OptionOriginal } from "PFTypes/options";
import { useCallback } from "react";

import { SelectProps } from "../select.types";

type UseSelectionCommit<T> = {
  dropdownId: string;
} & Pick<SelectProps<T>, "multiple" | "fetchOptions" | "onChange">;

export const useHandleSelection = <T extends OptionOriginal = OptionOriginal>({
  dropdownId,
  multiple,
  fetchOptions,
  onChange
}: UseSelectionCommit<T>): SelectProps<T>["onChange"] => {
  const queryClient = useQueryClient();

  return useCallback(
    (next: Option<T> | Option<T>[]) => {
      if (multiple && fetchOptions && Array.isArray(next)) {
        const ids = next.map(({ id }) => id);
        queryClient.setQueryData<FetchOptionsResponse<T>>(
          optionsKeys.dropdownWithParams(dropdownId, "", ids),
          (previous) => ({
            entries: next,
            meta: previous?.meta ?? { total: next.length }
          })
        );
      }
      onChange(next);
    },
    [queryClient, dropdownId, multiple, fetchOptions, onChange]
  );
};
